export default __webpack_public_path__ + "static/media/plugPdf.5bb87a74.svg";